import React from 'react';
import Loading from '../../../components/Loading';
import ReactModal from '../../../components/Modal';
import { withTranslation } from 'react-i18next';

class AddNewProjectModal extends React.Component {
    constructor() {
        super();

        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.state = {
            value: '',
            message: '',
        };
    }

    handleChange(e) {
        this.setState({ value: e.target.value });
    }

    async onSubmit(e) {
        try {
            e.preventDefault();
            if (!this.state.value) return;
            this.props.onSubmit(this.state.value);
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <ReactModal modalState={this.props.isOpen} className="width-sm ai-tracking-modal">
                    <h3>{t('ai_tracking.add_project.header')}</h3>
                    <form onSubmit={this.onSubmit}>
                        <p className="ai-tracking-modal-body">
                            <label>{t('ai_tracking.add_project.project_name')}</label>
                            <input
                                className="form-control"
                                type="text"
                                onChange={this.handleChange}
                                value={this.state.value}
                            />
                        </p>
                        <div className="btn-wrapper ai-tracking-modal-footer">
                            <button
                                type="button"
                                className="button button-outline button-primary width-sm btn"
                                onClick={this.props.onClose}
                                style={{ lineHeight: 'unset' }}
                            >
                                {t('ai_tracking.add_project.cancel')}
                            </button>
                            <button
                                className="button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center"
                                disabled={this.props.loading}
                            >
                                <span style={{ marginRight: '5px' }}>
                                    {t('ai_tracking.add_project.create')}
                                </span>
                                {this.props.loading && <Loading onlyPreloader />}
                            </button>
                        </div>
                    </form>
                </ReactModal>
            </>
        );
    }
}

export default withTranslation()(AddNewProjectModal);
